var _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScriptThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 142,
    viewBox: "0 0 210 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Title:_Top_10_Reasons_to_Get_a_Dog:_Unleash_the_Joy_Are_you_considering_getting_a_furry_companion_to_brighten_up_your_days_Look_no_further_Dogs_are_more_than_just_pets_they_re_loyal_loving_and_bundles_of_joy_If_you_re_on_the_fence_we_re_here_to_nu",
    "data-name": "Title: Top 10 Reasons to Get a Dog: Unleash the Joy! Are you considering getting a furry companion to brighten up your days? Look no further! Dogs are more than just pets; they\\u2019re loyal, loving, and bundles of joy! If you\\u2019re on the fence, we\\u2019re here to nu",
    transform: "translate(1)",
    fill: "#08231b",
    fontSize: 2.65,
    fontFamily: "Rubik-Regular, Rubik",
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2
  }, "Title: Top 10 Reasons to Get a Dog: Unleash the Joy!"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "Are you considering getting a furry companion to brighten up your days? Look no further! Dogs are more than just pets; they\u2019re loyal, loving, and bundles "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "of joy! If you\u2019re on the fence, we\u2019re here to nudge you in the right direction with the top 10 reasons why getting a dog will undoubtedly enhance your life!"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Unconditional Love: Dogs have a unique talent for showering you with unconditional love. Whether you\u2019re dressed to impress or having a bad hair day, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "your dog will adore you just the way you are. Their wagging tail and happy eyes will make you feel like the most cherished human on the planet."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Stress-Relief Experts: Feeling stressed after a long day at work? Your furry friend has got you covered! Scientific studies have shown that spending time "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "with dogs can reduce stress hormones and increase feel-good chemicals in your brain. A few cuddles and belly rubs are the perfect remedy for a tough "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "day."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "Fit and Fabulous: Dogs are fitness enthusiasts! With their boundless energy, they\u2019ll keep you moving and grooving. Daily walks, playtime, and games of "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "fetch will ensure both you and your pup stay in tip-top shape. Who needs a gym membership when you have a furry personal trainer?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }, "Social Magnets: Ever noticed how dogs can break the ice in any social situation? These four-legged charmers are natural conversation starters. Whether "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 50
  }, "you\u2019re walking in the park or hanging out at a cafe, people can\u2019t resist coming over to say hello to your adorable companion."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 56
  }, "Comedy Central: Get ready for endless laughs and moments of pure amusement. Dogs have an uncanny ability to do the funniest things, and they never "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 59
  }, "fail to bring smiles to our faces. From silly antics to quirky behaviors, you\u2019ll have your very own comedy show at home."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 62
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }, "Unbreakable Bonds: Getting a dog means forging a lifelong friendship. Dogs are incredibly loyal creatures who will stand by your side through thick and "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 68
  }, "thin. The bond you create with your dog is a beautiful and unbreakable connection that words can\u2019t describe."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 74
  }, "Stress-Free Alone Time: Worried about feeling lonely? Fear not! Dogs are fantastic companions and can keep you company when you\u2019re alone. They\u2019ll "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 77
  }, "snuggle up with you on the couch, offering comfort and warmth on those quiet evenings."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 80
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 83
  }, "Teach Us Valuable Lessons: Dogs are wise teachers disguised in fluffy coats. They remind us to live in the present moment, love unconditionally, and find "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 86
  }, "joy in the little things. The lessons they impart can be transformative, making us better human beings."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 89
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 92
  }, "Improve Mental Health: Dogs are not only good for your physical well-being but also your mental health. They can help reduce symptoms of anxiety and "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 95
  }, "depression, providing a sense of purpose and a constant source of comfort."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 101
  }, "Love Personified: Last but not least, dogs are love personified. Their presence in your life can fill it with immeasurable love, joy, and happiness. They will "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "become an integral part of your family, leaving pawprints on your heart forever."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 107
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 110
  }, "In conclusion, getting a dog is a decision you won\u2019t regret. From the boundless love they offer to the laughter they bring, these furry companions enrich "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 113
  }, "our lives in countless ways. So, if you\u2019re ready for a life full of love, laughter, and loyalty, go ahead and welcome a dog into your home. Your heart will "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 116
  }, "thank you, and your new furry friend will be forever grateful for the love and care you provide."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptThumb);
export default __webpack_public_path__ + "static/media/scriptThumb.0d3d7d7f6afaf63edc62a92c097685b6.svg";
export { ForwardRef as ReactComponent };